import React from "react";

const About = () => {
  const sections = [
    {
      name: "Dr. S. Arulrhaj",
      image: "/arhulraj.png",
      title: "Dr. S. Arulrhaj",
      subtitle: "Chairman",
      bio: "Dr. S. Arulrhaj is a highly esteemed medical professional with over 42 years of distinguished service as a Senior Physician, specializing in cardiology and intensive care. A gold medallist in MD (Medicine), he has been a pioneering force in the healthcare sector, contributing to medical education, clinical excellence, and global health leadership. He currently serves as the President of the Commonwealth Medical Association and President-Elect of the Association of Physicians of India (API). His extensive contributions to the medical community include founding and leading esteemed institutions such as the Commonwealth Medical Association Trust (UK), Commonwealth Medical eVarsity, and the Indo Global Cardio Diabetes Academy. Dr. Arulrhaj has held prestigious positions, including Past President of the Commonwealth Medical Association (UK), Past National President of the Indian Medical Association (IMA), and Founder & Past Chairman of the Commonwealth Health Professions Alliance (UK). His commitment to advancing medical knowledge is further reflected in his roles as Honorary Professor at IMA and Adjunct Professor of Medicine at Dr. MGR Medical University, Chennai. As the Chairman & Head of Acute Medicine at Sundaram Arulrhaj Hospitals and the Founder & Chairman of the Aruls Groups, Dr. Arulrhaj remains dedicated to delivering excellence in patient care, medical research, and healthcare education. His legacy continues through the Dr. S. Arulrhaj Health Education & Research Foundation, fostering innovation and excellence in medical practice.",
    },
    {
      name: "Mr. Rajanikant M. Torgal",
      image: "/rajanikant.png",
      title: "Rajanikant M. Torgal",
      subtitle: "Founder & CEO",
      bio: "Rajanikant M. Torgal is the visionary Founder & CEO of LifeOnPlus, a groundbreaking digital health ecosystem designed to transform preventive and non-invasive healthcare in India and beyond. With over three decades of experience across telecommunications, AI, and health technology, Mr. Torgal has emerged as a pioneering force in the HealthTech sector. His mission is to bridge global healthcare gaps through innovation, affordability, and accessibility. From leading mobile technology ventures to launching India's first integrated Smart Health Card and Body Recharge Station, Rajanikant Torgal's journey reflects a relentless commitment to empowering lives through intelligent healthcare. Today, he stands at the forefront of a global movement to redefine how the world experiences wellness and digital health.",
    },
    {
      name: "Mr. Peter Yeo",
      image: "/peter.png",
      title: "Mr. Peter Yeo",
      subtitle: "Chief Marketing Officer",
      bio: "Mr. Peter Yeo is a seasoned marketing professional with over 40 years of diverse industry experience, specializing in consumer and semiconductor marketing. A qualified Marine Engineer by profession, he later transitioned into marketing, bringing a unique blend of technical expertise and strategic business acumen. With 10 years in consumer marketing and 30 years in semiconductor marketing, Mr. Yeo has gained extensive international and regional exposure across Europe and the Asia-Pacific region. He has held top management positions in both MNCs and SMEs, leading global marketing strategies, managing key accounts, and driving business growth on an international scale. A graduate of Curtin University of Technology with a Bachelor’s degree in Commerce, he possesses deep expertise in global marketing, strategic brand positioning, and high-value client management. His leadership and industry insights continue to shape innovative marketing strategies, making a significant impact on business expansion and brand development.",
    },
    {
      name: "Mr. Francis Tan",
      image: "/francis.png",
      title: "Mr. Francis Tan",
      subtitle: "Vice President, Marketing",
      bio: "Mr. Francis Tan is a senior marketing professional with over 25 years of experience in strategic planning, interactive development, and direct marketing. With a strong ability to drive creative and innovative marketing strategies, he brings enthusiastic and forward-thinking leadership to dynamic team environments. Currently leading the marketing division for China, the Philippines, and Indonesia, Mr. Tan specializes in market expansion, brand positioning, and customer engagement strategies across diverse international markets. His expertise in developing high-impact marketing campaigns and driving business growth makes him a key force in the company's global marketing initiatives.",
    },
    {
      name: "Mr. Sanjay Gandhi",
      image: "/sanjay.png",
      title: "Mr. Sanjay Gandhi",
      subtitle: "Director, International Projects",
      bio: "Mr. Sanjay Gandhi is a seasoned industry leader with extensive experience in supply chain management, technology-driven transformation, operations strategy, and business development. With a career spanning top management roles at FedEx and DHL across the Asia-Pacific region, as well as Bajaj Auto and L&T in India, he brings a wealth of expertise in logistics, operations, and strategic growth initiatives. In addition to his corporate leadership, Mr. Gandhi is a part-time faculty member at Nanyang Technological University, Singapore, where he shares his industry insights with aspiring professionals. He also serves as a mentor and advisor to startups in Healthcare, Logistics, and Technology, supporting their business development, go-to-market strategies, and operational rollouts. With his deep industry knowledge and global experience, Mr. Gandhi plays a key role in driving international projects, strategic expansion, and operational excellence for the organization.",
    },
    {
      name: "Mr. Sachin D. Agrawal",
      image: "/sachin.png",
      title: "Mr. Sachin D. Agrawal",
      subtitle: "Director, Head of Marketing",
      bio: "Mr. Sachin D. Agrawal is a seasoned professional in Pharma Marketing with over 15 years of experience in the pharmaceutical industry. A Pharmacy graduate from Poona College of Pharmacy, he has worked in pharmaceutical manufacturing units and is an approved competent person for the tablet section. Throughout his career, he has held various leadership positions in renowned pharmaceutical companies, driving strategic marketing initiatives and business growth. In addition to his expertise in pharmaceutical marketing, he has been a Director at a Critical Care & Trauma Centre, showcasing his deep understanding of the healthcare sector. Mr. Agrawal is also well-versed in the financial sector, having served as a Director in investment firms such as Gandhish Brokers LLP. He currently holds the position of Director (Marketing) at Omni Orthotechnics Pvt. Ltd., where he specializes in providing innovative business solutions to drive growth and market expansion. With his extensive experience in healthcare, finance, and marketing, Mr. Agrawal plays a key role in shaping business strategies and delivering impactful marketing solutions.",
    },
    {
      name: "Mr. Rajendra Bagrecha",
      image: "/rajendra.jpeg",
      title: "Mr. Rajendra Bagrecha",
      subtitle: "Head - Channel Partner",
      bio: `Rajendra Bagrecha is a dynamic businessman and entrepreneur with extensive experience across multiple business sectors, including industrial products, business services, and real estate ventures. With a strong entrepreneurial background and strategic business vision, he has been actively associated with LifeOnPlus and its sister concern companies for the past 10 + years, contributing significantly to the organization’s growth, expansion, and business development activities.`,
    },
  ];

  const cards = [
    {
      title: "Our Vision",
      image: "/vision.png",
      description:
        "To transform healthcare by enabling patients to high quality healthcare services via our technology-enabled platform",
    },
    {
      title: "Our Vision",
      image: "/vision.png",
      description:
        "To empower every individual with seamless access to preventive and personalized healthcare by integrating advanced technology, smart health solutions, and holistic wellness practices—creating a connected, inclusive, and healthier world.",
    },
  ];

  const advisoryTeam = [
    {
      name: "Dr. S. Arulrhaj",
      image: "/arhulraj.png",
      subtitle: "Eminent Physician & Healthcare Visionary",
    },
    {
      name: "Rajanikant M. Torgal",
      image: "/rajanikant.png",
      subtitle:
        "Tech entrepreneur with 30+ years in global product innovation Medical & Technology Advisors Across India, Singapore, and Canada",
    },
  ];

  return (
    <div className="w-full overflow-hidden">
      {/* New Banner - Green Theme */}
      <div className="relative w-full h-[200px] md:h-[200px] bg-gradient-to-br from-emerald-700 via-green-700 to-teal-700 flex items-center justify-center overflow-hidden">
        <div className="relative z-10 text-center px-6 max-w-lg">
          <div className="inline-flex items-center gap-2 px-5 py-2 bg-white/10 backdrop-blur-md rounded-full text-white/90 text-xs tracking-[1px] font-medium mb-6">
            <span className="w-2 h-2 bg-emerald-300 rounded-full animate-pulse"></span>
            LIFEONPLUS
          </div>

          <h1 className="text-3xl md:text-4xl font-bold text-white tracking-tighter">
            About Us
          </h1>

          <p className="mt-3 text-white/80 text-[15px] leading-relaxed">
            Redefining preventive healthcare through innovation
          </p>
        </div>
      </div>
      <div className="max-w-[1180px] mx-auto px-5 sm:px-6 lg:px-8 py-12 space-y-16">
        {/* Our Story */}
        <div className="text-center space-y-4">
          <h2 className="text-2xl md:text-3xl font-bold text-black">
            Our Story
          </h2>
          <p className="max-w-3xl mx-auto text-sm md:text-base text-gray-600 leading-relaxed px-4">
            LifeOnPlus was founded with a bold vision: to bridge the gap between
            healthcare and everyday accessibility. Born out of real-world
            experiences in global healthcare and technology sectors...
          </p>
        </div>

        {/* Vision & Mission - Compact & Centered */}
        <div className="max-w-2xl mx-auto">
          <div className="grid md:grid-cols-2 gap-6">
            {cards.map((card, i) => (
              <div
                key={i}
                className="bg-white p-6 rounded-2xl shadow-sm hover:shadow-md transition-all border border-gray-100"
              >
                <div className="flex flex-col items-center text-center space-y-4">
                  <div className="w-12 h-12 bg-emerald-50 rounded-2xl flex items-center justify-center">
                    <div
                      className="w-8 h-8 bg-cover bg-center"
                      style={{ backgroundImage: `url(${card.image})` }}
                    />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900">
                    {card.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {card.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Founder’s Message - Better Balanced */}
        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow p-7 md:p-9 flex flex-col md:flex-row gap-7 items-center">
          <div className="md:w-56 flex-shrink-0">
            <img
              src="/rajanikant.png"
              alt="Founder"
              className="w-full rounded-2xl shadow-md"
            />
          </div>
          <div className="space-y-4 text-center md:text-left">
            <p className="text-sm text-gray-700 leading-relaxed italic">
              “The idea of LifeOnPlus was born during my journey across
              continents where I witnessed how technology could transform
              lives...”
            </p>
            <div>
              <div className="font-semibold text-lg">Rajanikant M. Torgal</div>
              <div className="text-emerald-600 text-sm">
                Founder &amp; CEO, LifeOnPlus
              </div>
            </div>
          </div>
        </div>

        {/* Advisory Board - Centered & Compact */}
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl font-bold text-center mb-8">
            Leadership &amp; Advisory
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            {advisoryTeam.map((member, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow transition-all"
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-60 object-contain"
                />
                <div className="p-6">
                  <h3 className="font-semibold text-lg text-gray-900">
                    {member.name}
                  </h3>
                  <p className="text-xs text-gray-500 mt-1 leading-snug">
                    {member.subtitle}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Team Profiles */}
        <div className="space-y-12">
          <h2 className="text-2xl font-bold text-center">
            Our Leadership Team
          </h2>

          {sections.map((section, index) => (
            <div
              key={index}
              className={`flex flex-col lg:flex-row gap-8 lg:gap-12 items-start bg-white p-6 lg:p-8 rounded-2xl shadow-sm hover:shadow transition-all border border-gray-100 ${index % 2 === 1 ? "lg:flex-row-reverse" : ""}`}
            >
              <div className="lg:w-60 flex-shrink-0">
                <img
                  src={section.image}
                  alt={section.name}
                  className="w-full aspect-square object-cover rounded-xl shadow"
                />
              </div>

              <div className="flex-1 space-y-3 pt-1">
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">
                    {section.title}
                  </h3>
                  <p className="text-orange-600 text-sm">{section.subtitle}</p>
                </div>
                <p className="text-xs text-gray-600 leading-relaxed">
                  {section.bio}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default About;
